function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "#5AB68F"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.0962,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.52131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.8931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7339 6.7207C18.3945 7.38107 17.897 7.98109 17.2698 8.48651C16.6426 8.99193 15.898 9.39285 15.0786 9.66639C14.2592 9.93992 13.3809 10.0807 12.4939 10.0807C11.6069 10.0807 10.7287 9.93992 9.90921 9.66639C9.08976 9.39285 8.3452 8.99193 7.71802 8.48651C7.09084 7.98109 6.59333 7.38107 6.25391 6.7207",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var Svg1HardlyNoticeable = function Svg1HardlyNoticeable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1HardlyNoticeable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1_Hardly_Noticeable.bad5e29a.svg";
export { ForwardRef as ReactComponent };